import bowser from 'bowser';

import type { SubscriptionsWebAnalyticsProperties } from '@calm-web/api-sdk/lib/atlas-subscriptions-api';

import { getSlug } from './setupEventProps';

export default function getSubscriptionsWebAnalyticsProperties(
	pageName?: string,
): SubscriptionsWebAnalyticsProperties {
	const slug = getSlug();
	const browser = bowser.getParser(window?.navigator?.userAgent || '');
	const browserInstance = browser.getBrowser();
	return {
		slug,
		service: 'web-www',
		browser: browserInstance.name,
		browserVersion: browserInstance.version,
		pageName,
		url: window.location.href,
	};
}
